/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import { externalRatingReviewsReducers } from 'ui-rating-review/src/reducers';
import { reducers as permitContentReducers } from 'ui-permit/shared-components/slices/permitContent';

import moduleReducers from '../src/reducers';
import moduleStore from '../src/store';

const initialState = {
    ...moduleStore(),
    ...sarsaparillaStore(),
};

const rootReducer = combineReducers({
    vehiclepermit: moduleReducers,
    permitContent: permitContentReducers,
    // Ratings and review reducers
    ratingReviews: externalRatingReviewsReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

export function setupStore(preloadedState?: any) {
    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                immutableCheck: {
                    ignoredPaths: ['vehiclepermit'],
                },
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly'],
                },
            });
        },
    });

    return store;
}

const store = setupStore(initialState);
const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

export { store, persistor };

// cSpell:ignore vehiclepermit persistor
